import { put } from './base';
import constants from '../../config/constants';

export const putMethod = (endPoint, jsonData,params) => {
    const url = constants.BASE_URL + endPoint;
    return put(url, { jsonData }, params);
};
